import { ShaderStore } from "@babylonjs/core";
const name = "clipFragmentDeclaration";
const shader = `#if defined(HOLOGRAPHIC_BOUNDS_BOX) || defined(HOLOGRAPHIC_BOUNDS_CYLINDER) || defined(HOLOGRAPHIC_BOUNDS_SPHERE)
varying vec4 vfClipDistance;#endif
`;
ShaderStore.IncludesShadersStore[name] = shader;
export const clipFragmentDeclaration = { name, shader };
//# sourceMappingURL=clipFragmentDeclaration.js.map